import { api } from './client';

export interface OnboardingSettings {
  whitelist_enabled: boolean;
  source: 'admin' | 'env';
}

export async function fetchOnboardingSettings(): Promise<OnboardingSettings> {
  const { data } = await api.get<OnboardingSettings>('/admin/onboarding/settings');
  return data;
}

export async function updateOnboardingSettings(payload: { whitelist_enabled: boolean }): Promise<OnboardingSettings> {
  const { data } = await api.put<OnboardingSettings>('/admin/onboarding/settings', payload);
  return data;
}
